// extracted by mini-css-extract-plugin
module.exports = {"alert-heading":"view-alert_alert-heading__npCIX","alert-body":"view-alert_alert-body__v54Vl"};